<div class="login-container">
    <div class="wrapper">
        <form class="login-form">
            <span class="login-form-logo"></span>
        </form>
        <div class="sso" >
            Request in progress ...
        </div> 
    </div>
</div>